export const NLQ_HELP_TEXT = `<h3>Search has just got easier!</h3>
  <br/>
  <div>We are excited to introduce the BETA version of Seerist' NLQ (Natural Language Query) Search. NLQ uses Large Language Models to translate a plain speech question into a Seerist search query to make your life easier!</div>
  <br/>
  <div>You could use prompts like these:</div>
  <ul>
    <li>What’s the news on unrest in Washington DC yesterday?</li>
    <li>Show me verified events on the conflict in Ukraine for the past 7 days</li>
    <li>Show me the news for the most recent Hotspots</li>
    <li>Provide me with negative sentiment news and social media concerning the US election</li>
  </ul>`;
